var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unOuter mainOuter"},[_c('div',{staticClass:"container_un animated fadeInLeft ani_delay05"},[(_vm.loaded)?_c('iframe',{staticStyle:{"height":"100vh"},attrs:{"title":"bot","name":"botFrame","id":"botFrame","width":"100%","src":_vm.iframeSrc}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }